module.exports = __webpack_public_path__ + "media/application/images/svgs/cancer_card-c35d49a8d6f235bbfab13a746c85e5e6.svg";